<template>

<div id="step-one" class="pt-xs-9 pb-xs-3 px-xs-5 px-sm-9">

  <v-card>

    <v-toolbar
      color="primary"
      dark
      flat
    >
      <v-row>
        <v-col
          cols="12"
          lg="6"
        >

          <v-menu
            ref="dateDropdown"
            v-model="dateDropdown"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRangeFormat"
                label="Course Date Range"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateRange"
              range
              no-title
              :min="new Date().toISOString().substr(0, 10)"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="dateDropdown = false; dateRange = []; filterCourse()"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dateDropdown.save(dateRange); filterCourse()"
              >
                Filter
              </v-btn>
            </v-date-picker>
          </v-menu>


        </v-col>
        <v-col
          cols="12"
          lg="6"
        >
          <v-autocomplete
            chips
            clearable
            label="Courses Available"
            prepend-icon="school"

            v-model="courseSelected"
            :items="courseTypes"
            item-text="text"
            item-value="value"
            @change="filterCourse"
            :menu-props="{closeOnContentClick:true}"
          >
            <template v-slot:selection="data">
              <v-chip
                color="#063564"
                class="white--text"
                v-bind="data.attrs"
                :input-value="data.selected"
              >
                {{ data.item.value }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title
                    v-if=" data.item.text == data.item.value "
                    class="font-italic font-weight-bold text-left"
                  >
                    {{ data.item.text }}
                  </v-list-item-title>
                  <v-list-item-title
                    v-else
                    class="pl-5 text-left"
                  >
                    {{ data.item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>

        </v-col>

      </v-row>



    </v-toolbar>
    <v-container fluid>


      <v-layout v-if="loading" row wrap align-center justify-center fill-height>
        <v-flex md6 lg4>
          <p class="title">
            Getting courses...
          </p>
          <v-progress-circular
            indeterminate
            color="blue darken-2"
            :size="70"
            :width="7"
          ></v-progress-circular>
        </v-flex>
      </v-layout>

      <div v-if="notFound">
        <div class="">
          <i class="material-icons fs-100">cloud_off</i>
        </div>

        <p class="title">
          No Course Found
        </p>
        <p class="subheading">
          Trainer has not published any public course.
        </p>
      </div>


      <template v-for="(course, index) in courses">

        <v-row
         :key="index"
          v-if="course.visible && course.filtered == false"
          class="align-center justify-center fill-height mt-7"
        >
          <v-col
            cols="12"
            sm="3"
            md="2"
            lg="1"
            class="pb-0 pb-md-1"
          >
            <div class="date-circle">
              <div class="display-1 lh-1">
                {{ course.startDate | moment("DD") }}
              </div>
              <div class="subheading">
                {{ course.startDate | moment("MMM") }}
                <br>
                {{ course.startDate | moment("YYYY") }}
              </div>
            </div>
          </v-col>

          <v-col
            cols="12"
            sm="9"
            md="6"
            lg="7"
            class="text-sm-left text-xs-center"
          >
            <div class="title">
              {{ course.name }}
            </div>
            <div class="subheading">
              {{ course.code }}
            </div>
            <div class="">

            </div>
            {{ course.startDate | moment("hh:mmA") }} -
            {{ course.endDate | moment("hh:mmA") }}
            <br>
            {{ course.location }} {{ course.state }}
          </v-col>

          <v-col
            cols="12"
            sm="9"
            md="2"
            lg="2"
            offset-md="0"
            offset-sm="3"
            class="text-sm-left text-xs-center py-0"
          >
            <div class="headline font-weight-bold">
              $ {{ course.cost.toFixed(2) }}
            </div>

            <b>{{ course.vacancy }}</b> seat<span v-if="course.vacancy > 1">s</span> left
          </v-col>

          <v-col
            cols="12"
            sm="9"
            md="2"
            lg="2"
            offset-md="0"
            offset-sm="3"
            class="pb-xs-1"
          >

            <v-btn
              v-if="$store.getters.isBooked(course.instance)"
              outlined block tile color="indigo"
              disabled=true
            >
              <span>Enrolled</span>
            </v-btn>

            <v-btn
              v-else-if="course.vacancy > 0"
              outlined block tile color="indigo"
              @click="canContinue( course ); activeButton = course.instance"
              :class="{ 'active' : activeButton == course.instance }"
            >
              <span>Enrol</span>
              <v-icon>check</v-icon>
            </v-btn>

            <v-btn
              v-else
              outlined block tile color="indigo"
              disabled=true
            >
              <span>No Vacancy</span>
              <v-icon>check</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-divider class="my-5"></v-divider>
          </v-col>

        </v-row>


      </template>

      <div
        v-if="!notFound"
      >
        <v-pagination
          v-model="page"
          :length="filteredPageTotal"
          circle
          next-aria-label="next"
          @input="nextPage"

        ></v-pagination>
        <div class="body-2 mt-3 font-italic">
          {{ visibleCourses }} courses found
        </div>
      </div>


    </v-container>
  </v-card>


</div>
</template>

<script>
import axios from 'axios';
import axcelerate from './axcelerate.js';

export default {
  // props: ['clickedNext', 'currentStep'],

  data() {
    return {
      page: 1,
      displayLimit: 3,
      filteredPageTotal: 1,
      visibleCourses: 0,
      dateRange: [],
      dateDropdown: false,
      activeButton: '',
      courses: [],
      courseTypes: [],
      courseSelected: null,
      notFound: false,
      loading: true,
      error: null
    }
  },

  created() {
    var params = {};
    var uri = decodeURI(window.location.href);
    uri.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function( m, key, value ) {
        params[ key ] = value;
      }
    );

    if( params.agentID !== undefined ) {
      this.$store.dispatch( 'setAgentID', params.agentID );
    }

    if( params.course !== undefined ) {
      this.courseSelected = decodeURIComponent( params.course );
    }

    // var orgID = window.location.pathname.replace(/\D/g, '');
    var orgID = params.orgID;

    if( orgID ) {
      axios.get( axcelerate.getCourses( orgID ) )
      .then(response => {
        var i = 0;
        var visibility;
        var courseNames = [];
        var name = '';
        
        for(var course of response.data.courses) {
          name = course.COURSENAME.toLowerCase();

          courseNames.push( name );

          visibility = (i < this.page * this.displayLimit) ? true : false;

          this.courses.push({
            instance  : course.INSTANCEID,
            type      : name,
            name      : course.NAME,
            code      : course.CODE,
            location  : course.LOCATION,
            vacancy   : course.PARTICIPANTVACANCY,
            cost      : course.COST,
            state     : course.STATE,
            startDate : course.STARTDATE,
            endDate   : course.FINISHDATE,
            domainID  : course.DOMAINID,
            visible   : visibility,
            filtered  : false,
          });

          i++;
        }

        // Asending sort course names and remove duplicates
        courseNames = courseNames.sort().filter( (a, b) => courseNames.indexOf(a) === b );

        // Group course names into types for filter
        i = 0;
        var prevGroup = '';
        for( name of courseNames ) {
          var arr = name.split( "(" );

          var group = arr[0].trim();
          var type  = (arr.length == 2) ? arr[1].replace(")", "") : null;

          if( prevGroup != group  ) {
            if( prevGroup ) {
              this.courseTypes.push( {
                "divider": true
              } );
            }

            this.courseTypes.push( {
              "text" : group,
              "value": group
            } );

            prevGroup = group;
          }

          if( type != null ) {
            this.courseTypes.push( {
              "text" : type,
              "value": name
            } );
          }
        }


        this.loading = false;
        this.notFound = (this.courses.length == 0);
        this.filteredPageTotal = Math.ceil( this.courses.length / this.displayLimit );
        this.visibleCourses = this.courses.length;

        if( this.courseSelected ) {
          this.filterCourse();
        }

        this.$store.dispatch(
          'setOrganisation',
          {
            id: orgID,
            name: response.data.organisation.NAME
          }
        );

        if( params.courseID !== undefined ) {
          var courseFound = this.courses.find( e => e.instance == params.courseID );
          if( courseFound !== undefined ) {
            this.activeButton = courseFound.instance;
            this.canContinue( courseFound );
          }
        }

      });
    } else {
      this.loading = false;
      this.notFound = true;
    }

    

  },

  computed: {
    dateRangeFormat() {
      var formattedArray = [];
      for( var i=0; i<this.dateRange.length; i++ ) {
        formattedArray[i] = this.formatDate( this.dateRange[i] );
      }
      return formattedArray.join(' - ');
    },
  },

  methods: {
    resetCourseDisplay() {
      var course = null;
      var length = 0;
      for( course of this.courses ) {
        course.filtered = false;
        course.visible  = ( length < this.displayLimit) ? true : false;
        length += 1;
      }
    },

    filterCourse() {

      var fromDate = (typeof this.dateRange[0] === 'undefined') ? false : new Date( this.dateRange[0] );
      var toDate   = (typeof this.dateRange[1] === 'undefined') ? false : new Date( this.dateRange[1] );

      var course     = null;
      var courseDate = null;
      this.visibleCourses = this.courses.length;

      this.resetCourseDisplay();

      // Date Range
      if( fromDate != false && toDate != false ) {
        // Make sure the from Date is smaller than to Date
        if( fromDate > toDate ) {
          var tmp  = fromDate;
          fromDate = toDate;
          toDate   = tmp;
        }

        this.visibleCourses = 0;
        for( course of this.courses ) {
          courseDate = new Date( course.startDate.split(' ')[0] );
          if( courseDate.getTime() >= fromDate.getTime() && courseDate.getTime() <= toDate.getTime() ) {
            course.filtered = false;
            course.visible  = (this.visibleCourses < this.displayLimit) ? true : false;
            this.visibleCourses += 1;
          } else {
            course.filtered = true;
            course.visible  = false;
          }
        }

      // Single Date
      } else if( fromDate != false ) {
        this.visibleCourses = 0;
        for( course of this.courses ) {
          courseDate = new Date( course.startDate.split(' ')[0] );
          if( courseDate.getTime() == fromDate.getTime() ) {
            course.filtered = false;
            course.visible  = (this.visibleCourses < this.displayLimit) ? true : false;
            this.visibleCourses += 1;
          } else {
            course.filtered = true;
            course.visible  = false;
          }
        }
      }



      if( this.courseSelected !== null && this.courseSelected !== undefined ) {
        var numVisible = 0;
        for( course of this.courses ) {
          // For the not yet filtered out courses by date range
          if( !course.filtered ) {

            // filter course names that don't contain selected
            if( !course.type.includes( this.courseSelected ) ) {
              course.filtered = true;
              this.visibleCourses -= 1;
            } else {
              // course.visible = (length < this.displayLimit) ? true : false;
              course.visible = (numVisible < this.displayLimit) ? true : false;
              numVisible += 1;
            }

          }
        }
      }


      if( this.visibleCourses < 1 ) {
        this.notFound = true;
      } else {
        this.notFound = false;
      }

      this.page = 1;
      this.filteredPageTotal = Math.ceil( this.visibleCourses / this.displayLimit );
    },
    formatDate( date ) {
      if( !date ) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    canContinue( course ) {
      this.$store.dispatch( 'setCourse', course );
      this.$emit('can-continue', {value: true});
      this.$parent.nextStep();

    },
    nextPage() {
      var offset = (this.page - 1) * this.displayLimit;
      var filteredCourses = [];
      var index = 0;
      var course;
      for( course of this.courses) {
        if( !course.filtered ) {

          filteredCourses[ filteredCourses.length ] = course;
        }
      }
      for( course of filteredCourses ) {
        if( index >= offset && index < (offset + this.displayLimit) ) {
          course.visible = true;
        } else {
          course.visible = false;
        }
        index += 1;
      }

    }
  },

  watch: {
    $v: {
      handler: function (val) {
        if(!val.$invalid) {
          this.$emit('can-continue', {value: true});
        } else {
          this.$emit('can-continue', {value: false});
          setTimeout(()=> {
            this.$emit('change-next', {nextBtnValue: false});
          }, 3000)
        }
      },
      deep: true
    },

  },

  activated() {
    if( document.querySelector('#step-one button.active') !== null ) {
      this.$emit('can-continue', {value: true});
    }
  },
}
</script>
